import { AfterViewInit } from '@angular/core';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { UnsavedAlertComponent } from 'src/app/shared/components/unsaved-alert/unsaved-alert.component';
import { ValidationPopupComponent } from 'src/app/shared/components/validation-popup/validation-popup.component';
import { HttpService } from 'src/app/shared/services/http.service';
import { TableService } from 'src/app/shared/services/tableService/table.service';

@Component({
  selector: 'app-edit-rate-agreement',
  templateUrl: './edit-rate-agreement.component.html',
  styleUrls: ['./edit-rate-agreement.component.scss'],
})
export class EditRateAgreementComponent implements AfterViewInit {
  dataSource: any;
  operation: any;

  selectedTab = 0;
  actualData: any;
  userData: any;
  prevOption = false;
  isCopy = false;

  @ViewChild('information', { static: false }) information: any;
  @ViewChild('ratetable', { static: false }) ratetable: any;
  @ViewChild('export_pdf') exportPDFRef!: any;
  @ViewChild('export_excel') exportExcelRef!: any;

  constructor(
    public appService: AppService,
    private httpService: HttpService,
    private tableService: TableService,
    private dialog: MatDialog,
    private router: Router
  ) {
    this.dataSource = history.state.data;
    this.appService.infromationData = this.dataSource;
    this.appService.enableExport = false;
    this.appService.raIsLoading = true;
    this.appService.exportPDFTableList = [];
    this.operation = history.state.operation;
    let userData = sessionStorage.getItem('user-data');
    this.userData = userData ? JSON.parse(userData) : null;
    this.appService.approveBtnClicked = false;

    this.isCopy = false;
    if (this.operation != 'add') {
      this.prevOption = false;
      if (this.userData.RoleID != 4) {
        this.operation = 'view';
      } else {
        this.prevOption = false;
        if (this.dataSource.RateAgreementStatusID !== 39) {
          this.operation === 'edit'
            ? (this.prevOption = true)
            : (this.prevOption = false);
          this.operation = 'view';
        }
      }
    }
    // let subscriber = this.appService.matrixEmitter
    // .subscribe((evt:string) =>{
    //     subscriber.unsubscribe();
    // })
    if (this.appService.testSubsciber)
      this.appService.testSubsciber.unsubscribe();
    if (this.appService.matrixSubscriber)
      this.appService.matrixSubscriber.unsubscribe();
    if (this.appService.saveSubscrier)
      this.appService.saveSubscrier.unsubscribe();

    this.appService.rateDateSource = [];
    this.appService.rateTableList = [];
    this.appService.rateOutputData = [];
    // let subscriber = this.appService.matrixEmitter.subscribe((evt:string) =>{
    //   this.appService.isAddMaxtrix = false;
    //   subscriber.unsubscribe();
    // })

    // if(this.operation !="add"){
    //   ['version','attachment'].forEach((i:any) =>{
    //     this.httpService.onDownlaodFiles(i,this.dataSource.RateAgreementID)
    //     .subscribe((res:any) =>{
    //   })
    // })
    // }
  }

  ngAfterViewInit(): void {
    this.appService.onRAvalueChanged = false;
  }

  onbackCall() {
    if (this.appService.onRAvalueChanged && this.operation != 'view') {
      const dialogRef = this.dialog.open(UnsavedAlertComponent, {
        disableClose: false,
      });
      dialogRef.afterClosed().subscribe((evt: any) => {
        if (evt.operation === 'confirm') {
          this.router.navigateByUrl('/home/rate-agreement');
          if (this.operation === 'add') {
            this.httpService.onClearIntialFile().subscribe((res: any) => {});
          }
        }
      });
    } else {
      this.router.navigateByUrl('/home/rate-agreement');
      if (this.operation === 'add') {
        this.httpService.onClearIntialFile().subscribe((res: any) => {});
      }
    }
  }

  onApproveBtnClick() {
    if (this.operation === 'view' || this.operation === 'add') {
      return;
    }
    // if(this.appService.saveSubscrier)
    //   this.appService.saveSubscrier.unsubscribe();

    this.isCopy = false;
    this.onApprovalValidaton();
    // this.onSave();
  }

  onApprovalValidaton() {
    if (this.information.agreementForm.get('effectiveDate')?.invalid) {
      this.httpService.openSnackBar('Please select the Effective Date');
      return;
    } else if (this.information.agreementForm.get('expiryDate')?.invalid) {
      this.httpService.openSnackBar('Please select the Expiry Date');
      return;
    } else if (this.information.agreementForm.get('initalDate')?.invalid) {
      this.httpService.openSnackBar(
        'Please select the Intial Contract Effective Date'
      );
      return;
    } else if (this.information.agreementForm.get('gsdb')?.invalid) {
      this.httpService.openSnackBar('Please select the GSDB');
      return;
    } else if (this.information.agreementForm.get('contractName')?.invalid) {
      this.httpService.openSnackBar('Please select the Contact Name');
      return;
    } else if (this.information.agreementForm.get('buyermail')?.invalid) {
      this.httpService.openSnackBar('Please select the Buyer Email');
      return;
    } else if (this.information.agreementForm.get('description')?.invalid) {
      this.httpService.openSnackBar('Please enter the Description of Service');
      return;
    } else if (this.information.agreementForm.get('autoExtent')?.invalid) {
      this.httpService.openSnackBar('Please select the Auto Extension Flag');
      return;
    } else if (
      this.information.agreementForm.get('autoExtent')?.value === 'Yes' &&
      this.information.agreementForm.get('noticePeriod')?.invalid
    ) {
      this.httpService.openSnackBar('Please enter the Notice Period');
      return;
    } else if (
      this.information.agreementForm.get('autoExtent')?.value === 'Yes' &&
      this.information.agreementForm.get('renewal')?.invalid
    ) {
      this.httpService.openSnackBar('Please enter the Renewal');
      return;
    } else if (this.information.agreementForm.get('duration')?.invalid) {
      this.httpService.openSnackBar('Please enter the Contract Duration');
      return;
    } else if (this.information.agreementForm.get('payment')?.invalid) {
      this.httpService.openSnackBar('Please enter the Payment Term');
      return;
    } else if (this.information.agreementForm.get('commodity')?.invalid) {
      this.httpService.openSnackBar('Please select the Commodity');
      return;
    } else if (this.information.agreementForm.get('retentionPeriod')?.invalid) {
      this.httpService.openSnackBar('Please enter the Record Retention Period');
      return;
    }

    // ------------------ rate table validation ----------------------
    for (let i = 0; i < this.appService.rateDateSource.length; i++) {
      let item = this.appService.rateDateSource[i];

      if (item.RateTableName === '' || item.RateTableName === null) {
        this.httpService.openSnackBar('Please enter the Rate Table Name');
        return;
      } else if (!item.RateTableTypeID) {
        this.httpService.openSnackBar('Please select the Rate Table Type');
        return;
      } else if (item.IMCSSiteCode === '') {
        this.httpService.openSnackBar('Please select the GSDB Site Code');
        return;
      } else if (item.BidPackID === null) {
        this.httpService.openSnackBar('Please select the Bidpack Reference');
        return;
      } else if (item.TransportModeID === null) {
        this.httpService.openSnackBar('Please select the Transport Mode');
        return;
      } else if (item.FuelEscalatorFlag && item.DataSourceForFuelPrice === '') {
        this.httpService.openSnackBar(
          'Please enter the Data Source for Fuel Price'
        );
        return;
      } else if (
        item.FuelEscalatorFlag &&
        (item.CountryForFuelPriceID === '' || item.CountryForFuelPriceID === 0)
      ) {
        this.httpService.openSnackBar(
          'Please select the Country for Fuel Price'
        );
        return;
      } else if (item.FuelEscalatorFlag && item.FuelCostBaseline === 0) {
        this.httpService.openSnackBar(
          'Please enter the Fuel Cost for Baseline'
        );
        return;
      } else if (item.FuelEscalatorFlag && item.FuelCostBreakdown === 0) {
        this.httpService.openSnackBar(
          'Please enter the Fuel Cost for Breakdown'
        );
        return;
      } else if (item.FuelEscalatorFlag && item.FuelTrigger === 0) {
        this.httpService.openSnackBar('Please enter the Fuel Trigger');
        return;
      } else if (item.FuelEscalatorFlag && item.FuelEscalatorVersion === '') {
        this.httpService.openSnackBar(
          'Please enter the Fuel Escalator Version'
        );
        return;
      } else if (item.Remarks === '') {
        this.httpService.openSnackBar('Please enter the Remarks');
        return;
      }
    }
    this.httpService
      .getApprovalValidation(this.dataSource.RateAgreementID)
      .subscribe((res: any) => {
        if (
          res[0]?.DuplicateFlag === 1 ||
          res[0]?.DuplicateFlag === 2 ||
          res[0]?.DuplicateFlag === 3
        ) {
          this.onValidationCall(res[0]?.MSG);
        }
      });
  }

  onValidationCall(msg: string) {
    const dialogRef = this.dialog.open(ValidationPopupComponent, {
      disableClose: false,
      data: {
        title: '',
        message: msg,
      },
    });
    dialogRef.afterClosed().subscribe((evt) => {
      // dialogRef.close();
      if (evt.operation === 'yes') {
        this.appService.approveBtnClicked = true;
        this.onApprove();
      }
    });
  }

  onApprove() {
    // if(this.dataSource.IsApprove === 0){
    //   this.httpService.openSnackBar("Effective Date should be Today or Greater..!")
    //   return;
    // }
    if (this.operation === 'edit') {
      this.onSaveBtnClicked();

      // this.httpService.onApprove(this.dataSource.RateAgreementID, this.userData.UserID).
      // subscribe((res:any) =>{
      //   // ['version','attachment'].forEach((i:any) =>{
      //   // this.httpService.onApprovalRename(i,this.dataSource.RateAgreementID,res[0].RateAgreementID)
      //   // .subscribe((res:any) =>{
      //   //   console.log("res.......",res);
      //   // })
      // // })
      // if(res[0]?.DuplicateFlag === 1){
      //   this.httpService.openSnackBar("Combination of RA Number, Effective Date and Expiry Date already exists")
      // }
      // else if(res[0]?.DuplicateFlag === 2){
      //   this.httpService.openSnackBar("Effective Date of the Rate Agreement is prior to today")
      // }
      // else if(res[0]?.DuplicateFlag === 3){
      //   this.httpService.openSnackBar("Two different versions of the Rate Agreement cannot have same Effective Date as Today")
      // }
      // else{
      //   this.httpService.openSnackBar("Agreement Approved Successfully")
      //   this.router.navigateByUrl('/home/rate-agreement')
      // }
      // })
    }
  }
  onCopy() {
    if (this.operation !== 'add') {
      this.operation = 'edit';
      this.isCopy = true;
      // this.information.agreementForm.onCopyActivity();
      this.dataSource.RateAgreementStatusID = 39;
      // ['attachment'].forEach((i:any) =>{
      //   this.httpService.onCopyFileFolders(i,this.appService.rateTableList[this.appService.selectedItem].RateAgreementTableID,0)
      //   .subscribe((res:any) =>{
      //   })
      // })
      this.appService.rateDateSource.forEach((element: any) => {
        element.RateAgreementTableID = null;
      });
      this.appService.rateTableList.forEach((element: any) => {
        element.RateAgreementTableID = null;
      });
    }
  }

  onSaveBtnClicked(boo = true) {
    if (!boo) {
      this.appService.approveBtnClicked = false;
    }
    if (this.operation !== 'view') {
      if (!this.information.agreementForm.get('rateNumber')?.value) {
        this.httpService.openSnackBar('Please enter the Rate Agreement Number');
        return;
      }

      if (this.ratetable.rateTableForm.value.rateTableType === '') {
        this.httpService.openSnackBar('Please add atleast one Rate Table');
        return;
      }
      if (this.ratetable.rateTableForm.value.rateTable === '') {
        this.httpService.openSnackBar('Please enter the Rate Table Name');
        return;
      }

      if (!this.areNamesUnique()) {
        this.httpService.openSnackBar('Rate Table Name should be unique');
        return;
      }

      this.information.onSave();
      this.isCopy = false;
    }
  }

  areNamesUnique() {
    const namesSet = new Set(); // Using a Set to track unique names
    let array = this.appService.rateDateSource.map((i: any) =>
      i.RateTableName.toLowerCase()
    );
    for (const obj of array) {
      if (namesSet.has(obj)) {
        return false; // Duplicate found
      }
      namesSet.add(obj); // Add name to the Set
    }
    return true; // All names are unique
  }

  onSave() {
    this.isCopy = false;
    if (this.operation !== 'view') {
      if (this.information.agreementForm.invalid) {
        this.httpService.openSnackBar(
          'Please fill all the required fields in Information'
        );
        return;
      } else if (this.ratetable.rateTableForm.invalid) {
        this.httpService.openSnackBar(
          'Please fill all the required fields in Rate Table'
        );
        return;
      } else if (!this.ratetable.rateTableForm.get('transMode')?.value) {
        this.httpService.openSnackBar(
          'Please fill all the required fields in Rate Table'
        );
        return;
      } else {
        let obj =
          this.appService.rateDateSource[this.appService.selectedColumn];
        // if(obj.FuelCostBaseline === 0 || obj.FuelCostBreakdown === 0 || obj.FuelTrigger === 0){
        //   this.httpService.openSnackBar('Please fill all the required fields in Rate Table');
        //   return;
        // }
        // else if(obj.Remarks === ''){
        //   this.httpService.openSnackBar('Please fill all the required fields in Rate Table');
        //   return;
        // }
        this.information.onSave();
      }
    }
  }
  onExportAgreement(i: string) {
    const dropDownElement = document.getElementById('agreement-drop-down');
    if (dropDownElement) {
      dropDownElement.style.display = 'none';
    }
    if (this.operation !== 'add') {
      if (i === 'PDF') {
        this.exportPDFRef.onSavePDF();
      } else if (i === 'Excel') {
        this.exportExcelRef.onSaveExcel();
      }
      // if(this.selectedTab === 0){
      //   this.information.onExportFile(i);
      // }
      // else{
      //   this.ratetable.onOverallExport(i);
      // }
      // this.appService.openSnackBar("Agreement Approved Successfully")
    }
  }
  dropDownSelct() {
    const dropDownElement = document.getElementById('agreement-drop-down');
    if (dropDownElement) {
      if (dropDownElement.style.display === 'block') {
        dropDownElement.style.display = 'none'; // If it's "block", make it "none"
      } else {
        dropDownElement.style.display = 'block'; // If it's "none" or anything else, make it "block"
      }
    }
  }

  onDelete() {
    if (this.operation === 'edit') {
      this.tableService.deleteItem(
        'Rate Agreement',
        'RateAgreementTableID',
        this.appService.infromationData.RateAgreementID,
        this
      );
    }
  }

  onTaBSelection(evt: any) {
    this.selectedTab = evt;
  }
}
